import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { InboundDeliveryItemsByIdQuery } from "../../../graphql/deliveryService/queries/inboundDeliveryItemsById";
import { InboundDeliveryItemsFragment } from "../../../models/autogenerated-deliveryService-gql/graphql";
import { handleError } from "../../../utils/graphqlHelper";
import { isNullOrEmpty } from "../../../utils/helper";

interface InboundDeliveryItemsByIdQueryProps {
  id: string | undefined;
  dataAction: (data: InboundDeliveryItemsFragment) => void;
  errorAction?: () => void;
}

const useInboundDeliveryItemsByIdQuery = (
  props: InboundDeliveryItemsByIdQueryProps,
) => {
  const { t } = useTranslation();
  const { id, dataAction, errorAction } = props;

  const query = useQuery(InboundDeliveryItemsByIdQuery, {
    fetchPolicy: "network-only",
    //nextFetchPolicy: "cache-first",
    skip: isNullOrEmpty(id),
    variables: { inboundDeliveryByIdInput: { id } },
    errorPolicy: "all", //returns errors and data if both exist at the same time
  });

  const { data, error } = query;

  const inboundDeliveryItemsFragment = data?.inboundDeliveryById;

  useEffect(() => {
    if (!error) return;

    handleError(
      t("inboundDeliveryItemsByIdQueryError"),
      error.message,
      errorAction,
    );
  }, [error]);

  useEffect(() => {
    if (!data || !inboundDeliveryItemsFragment) return;

    dataAction(inboundDeliveryItemsFragment);
  }, [data]);

  return query;
};

export default useInboundDeliveryItemsByIdQuery;
